module.exports = __webpack_public_path__ + "img/gie-logo.24091f26.png";